import { API_BASE_URL, API_URL } from "@config/app";

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

const isCheckoutUrl = (value: string): boolean => {
  try {
    const api = new URL(API_URL, API_BASE_URL);
    const target = new URL(value, api);
    const prefix = `${api.pathname.replace(/\/+$/, "")}/store/clinics/`;
    return (
      target.origin === api.origin &&
      !target.username &&
      !target.password &&
      !target.search &&
      !target.hash &&
      target.pathname.startsWith(prefix) &&
      /^[A-Za-z0-9_-]+\/checkout$/.test(target.pathname.slice(prefix.length))
    );
  } catch {
    return false;
  }
};

export const isStoreWebSessionExpiredFailure = (error: unknown): boolean => {
  if (!isRecord(error)) return false;
  const { config, response } = error;
  if (
    !isRecord(config) ||
    !isRecord(response) ||
    config.withCredentials !== false ||
    config.withXSRFToken !== false ||
    typeof config.method !== "string" ||
    config.method.toLowerCase() !== "post" ||
    typeof config.url !== "string" ||
    !isCheckoutUrl(config.url) ||
    !isRecord(config.headers) ||
    response.status !== 401 ||
    !isRecord(response.data) ||
    response.data.reason !== "web_session_expired" ||
    response.data.retryable !== false
  ) {
    return false;
  }

  return Object.entries(config.headers).some(
    ([name, value]) =>
      name.toLowerCase() === "web-session" &&
      typeof value === "string" &&
      value.trim().length > 0,
  );
};
